import "./styles/Sobre.css";

function Sobre() {
  return (
    <div className="sobre-container">
      <div className="sobre-tittle-container">
        <div className="tittle">Sobre a Fanttech</div>
      </div>
      <div className="sobre-content-container">
        <div className="sobre-content-img-container">
          <img src="./assets/images/banner.png" alt="" />
        </div>
        <div className="sobre-content-text-container">
          <div className="sobre-content-text">
            <span>Visão inovadora, esse é o perfil da Fanttech Engenharia e Tecnologia. A Fanttech é uma empresa que oferece soluções inovadoras e criadoras de valor para seus clientes, bem como ótimo serviço técnico para manter sempre seus produtos em pleno funcionamento. Agilidade, segurança e preço justo são as características do serviço técnico Fanttech.</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sobre;
